<app-header login="yes"></app-header>
<div class="backgroundImage">
    <div class="container">
        <div class="d-flex justify-content-center h-100">
            <div class="responsive">
                <div class="card-wrapper">
                    <div class="login-screen-area">
                        <h4 style="font-size: 30px">Login</h4>
                    </div>
                    <div class="content-part"><img src="assets/splash_logo.png" /></div>
                    <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
                        <div class="form-field">
                            <button routerLink="/claim-list" type="button" class="google btn btn-lg btn-block">
                                <div class="row align-items-center">
                                    <div class="col-md-1 col-sm-2">
                                        <span class="icon-name d-inline-block"><i
                                                class="fas fa-search color"></i></span>
                                    </div>
                                    <div class="col-md-11 col-sm-10 text-white" style="font-size: 16px">
                                        <span>Search & Claim Your Ministry</span>
                                    </div>
                                </div>
                            </button>
                        </div>
                        <div class="text-center align-items-center my-4 login_up">
                            <!-- <span class="text-light">Can't Find Your Ministry?</span> -->
                            <!-- <button type="button" (click)="openSignUpPage()" class="btn w-100 btn-dark mt-2 btn-lg btnn">Create Ministry Profile</button> -->
                            <div class="d-flex justify-content-between align-items-center px-2">
                                <span class="text-light font-weight-bold">Already Have a Ministry Profile?
                                </span>
                                <!-- <span class="text-light or">OR</span>
                                <span (click)="goToSignup()"
                                    class="text-light btn btn-sm btn-primary font-weight-bold mb-0">Sign Up</span> -->
                            </div>
                        </div>
                        <div>
                            <div class="form-group">
                                <input type="email" class="form-control input-height inputBox" formControlName="email"
                                    placeholder="Email" [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />
                                <div *ngIf="submitted && f.email.errors" class="invalid-feedback error">
                                    <span *ngIf="f.email.errors.required">{{
                                        errorMessage
                                        }}</span>
                                    <span *ngIf="f.email.errors.email">Email must be a valid email address</span>
                                </div>
                            </div>
                            <div class="form-group passwordform">
                                <input [type]="isShowPassword ? 'text' : 'password'"
                                    class="form-control inputBox input-height" formControlName="password"
                                    placeholder="Password"
                                    [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
                                <div *ngIf="submitted && f.password.errors" class="invalid-feedback error">
                                    <span *ngIf="f.password.errors.required">{{
                                        errorMessage
                                        }}</span>
                                    <span *ngIf="f.password.errors.minlength">Password must be at least 6 characters
                                    </span>
                                </div>

                                <div class="passicon">
                                    <span (click)="isPasswordShow()">
                                        <i [ngClass]="true ? 'fa fa-eye':'fa fa-eye-slash'"></i>
                                    </span>
                                </div>
                            </div>
                            <div class="forgotPassword">
                                <span class="rememberme ml-1">
                                    <input type="checkbox" [(ngModel)]="rememberMe" formControlName="rememberMe" />
                                    <span class="ml-2">Remember me</span>
                                </span>
                                <p routerLink="/forgot-password">Forgot Password?</p>
                            </div>
                        </div>
                        <div class="adjust-div sign-in-button">
                            <button type="submit" class="btn color">Sign in</button>
                        </div>
                        <div class="row">
                            <h4>Continue with ...</h4>
                        </div>
                        <div class="form-field">
                            <button (click)="facebookLogin()" type="button"
                                class="facebook btn btn-primary btn-lg btn-block">
                                <span class="icon-name"><i class="fab fa-facebook-f"></i></span>
                                <span class="icon-text">Facebook</span>
                            </button>
                            <button (click)="googleLogin()" type="button"
                                class="google1 btn btn-primary btn-lg btn-block">
                                <span class="icon-name"><i class="fab fa-google"></i></span>
                                <span class="icon-text">Google</span>
                            </button>
                            <button type="button" class="mail btn btn-primary btn-lg btn-block">
                                <span class="icon-name"><i class="fab fa-apple"></i></span>
                                <span class="icon-text">Apple</span>
                            </button>
                            <!-- <p> Don't have an account yet? <span class="sign-uplink" [routerLink]="['/sign-up']">
                                    Sign Up</span></p> -->
                        </div>
                        <div class="agree-text">
                            <span>By Signing Up you agree to the </span>
                            <a href="https://ravel.faith/policies/ravel-terms/" target="_blank">Terms of Services</a>
                            <span> and </span>
                            <a href="https://ravel.faith/policies/privacy-policy/" target="_blank">Privacy Policy</a>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>  
</div>
